import React, { Component } from 'react'
import { Row, Col, Button, Table, Modal, Popconfirm, Checkbox, Pagination, Select } from 'antd'
import PropTypes from 'prop-types'
import { api, app, config } from "../../app"
import utils from "../../utils"
import Loading from "../../components/Loading"
import _ from "underscore"
import ReviewSearch from "../../components/ReviewSearch"
import common from "./common2"

const Option = Select.Option

class ReSkill extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ppeList: [],
            ppeInfo: {},
            ppe_visible: false,
            dataType: '1',
            page: 1,
            total: 0,
            selectedRowKeys: [],
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = async (data) => {
        await app.setStateSync(this, data)
    }

    /**
     * 数据
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.PpeAuditList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }

        if (page === this.state.page) {

            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                ppeList: utils.addArrayKey(data),
                total: parseInt(total || '0'),
            })
        }
    }

    /**
     * 打开技能对话框
     * @param ppe_id
     * @param indexno
     * @constructor
     */
    OpenPpeModal = async (ppe_id, indexno) => {
        await this.setData({ ppe_visible: true, ppe_loading: true })
        let params = {
            ppe_id,
            object_indexno: indexno,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.PpeDetails, params)
        let state = { ppe_loading: false }
        if (flag === 1) {
            state.ppeInfo = data
        } else {
            app.alert(msg, "error")
        }
        await app.sleep()
        await this.setState(state)
    }

    /**
     * 关闭技能对话框
     * @constructor
     */
    ClosePpeModal = () => {
        this.setState({ ppe_visible: false, ppe_loading: false, ppeInfo: {} })
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }
    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.ppeList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, ppeList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => ppeList[index - 1].id).join(',')
        let reviewInfo = {
            id,
            uri: api.PpeAudit,
            id_key: "ppe_id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            this.props.successReview(1, "", reviewInfo)
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    render() {
        let { ppeList, ppeInfo, data_loading, ppe_visible, ppe_loading, dataType, selectedRowKeys, page, total } = this.state,
            rowSelection = null,
            tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let columns = [
            {
                title: '姓名',
                dataIndex: 'vname',
                key: 'vname',
                width: '7%'
            },
            {
                title: '队员编号',
                dataIndex: 'bsrno',
                key: 'bsrno',
                width: '7%'
            },
            {
                title: '所属队伍',
                dataIndex: 'teamname',
                key: 'teamname',
                width: '10%'
            },
            {
                title: '发证机构',
                dataIndex: 'organization_name',
                key: 'organization_name',
                width: '10%',
                render: (text) => (<span>{text || '无'}</span>)
            },
            {
                title: '审核技能',
                dataIndex: 'names',
                key: 'names',
                width: '12%',
            },
            {
                title: '提交时间',
                dataIndex: 'uptime',
                key: 'uptime',
                width: '13%',
                render: (text) => (<span>{text || '无记录'}</span>)
            },
            // {
            //     title: '一级审核',
            //     dataIndex: 'team_header_name',
            //     key: 'team_header_name',
            //     width: '7%',
            //     render: (text) => (<span>{text || '-'}</span>)
            // },
            // {
            //     title: '二级审核',
            //     dataIndex: 'admin_name',
            //     key: 'admin_name',
            //     width: '7%',
            //     render: (text) => (<span>{text || '-'}</span>)
            // },
            {
                title: '一级审核',
                dataIndex: 'team_header_audit',
                key: 'team_header_audit',
                width: '10%',
                render: (team_header_audit, { team_header_name, team_header_time, detail, status }) =>
                    common.tableStatus(team_header_audit, team_header_name, team_header_time, detail, status, 1)
            },
            {
                title: '二级审核',
                dataIndex: 'admin_audit',
                key: 'admin_audit',
                width: '10%',
                render: (admin_audit, { admin_name, admin_time, detail, status }) =>
                    common.tableStatus(admin_audit, admin_name, admin_time, detail, status, 2)
            },
            {
                title: '操作类型',
                dataIndex: 'type',
                key: 'type',
                width: '9%',
                render: (type) => {
                    let msg = '未知'
                    if (type === '0') {
                        msg = '添加'
                    } else if (type === '1') {
                        msg = '编辑'
                    }
                    return (<span>{msg}</span>)
                }
            },
            {
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: 250,
                render: (id, { indexno }) => {
                    let reviewInfo = {
                        id,
                        uri: api.PpeAudit,
                        id_key: "ppe_id",
                        source: () => this.dataSource(tp),
                    }, disabled = selectedRowKeys.length > 1
                    if (tp >= page) {
                        tp = page
                    }
                    return (
                        <Row type="flex" justify="center">
                            <Button size="small" icon="eye" onClick={() => this.OpenPpeModal(id, indexno)}>预览</Button>
                            {
                                dataType === '1' ? [
                                    (
                                        <Popconfirm key="1" placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={() => this.props.successReview(1, "", reviewInfo)}
                                        >
                                            <Button size="small" type="primary" style={{ margin: "0 20px" }}
                                                disabled={disabled}>通过</Button>
                                        </Popconfirm>
                                    ),
                                    (
                                        <Button key="2" size="small" type="danger" onClick={() => {
                                            this.props.failReview(reviewInfo)
                                        }} disabled={disabled} ghost>不通过</Button>
                                    )
                                ] : null
                            }


                        </Row>
                    )
                }
            }
        ]
        if (dataType === '1') {
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
        }
        // else {
        //     columns[7].width = '10%'
        //     columns.splice(7, 0, {
        //         title: '省管理员审核',
        //         dataIndex: 'admin_audit',
        //         key: 'admin_audit',
        //         width: '10%',
        //         render: (audit, { admin_name, admin_time, detail }) => common.tableStatus(audit, admin_name, admin_time, detail)
        //     })
        // }
        return (
            <div className="review-skill">
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <ReviewSearch onSearch={this.handleSearch} />
                </div>
                <Table columns={columns}
                    locale={app.tbLocale(data_loading)}
                    loading={data_loading}
                    pagination={false}
                    dataSource={ppeList}
                    scroll={{ y: 'calc(100% - 103px)' }}
                    style={{ height: 'calc(100% - 52px)' }}
                    rowSelection={rowSelection}
                    footer={() => {
                        return (
                            <Row hidden={ppeList.length === 0}>
                                <Col span={10}>
                                    <div hidden={dataType === '2'}>
                                        <Checkbox
                                            checked={ppeList.length !== 0 && ppeList.length === selectedRowKeys.length}
                                            onChange={this.handleAllSel}>全选</Checkbox>
                                        <Button style={{ margin: '0 20px' }} type="primary"
                                            onClick={() => this.handlePLReview(1)}>通过</Button>
                                        <Button type="danger" onClick={() => this.handlePLReview(2)}>不通过</Button>
                                    </div>
                                </Col>
                                <Col span={14} style={{ textAlign: 'right' }}>
                                    <Pagination total={total} size="small" pageSize={20} current={page}
                                        showTotal={(total) => `总数量：${total}`}
                                        onChange={this.handlePageChange} />
                                </Col>
                            </Row>
                        )
                    }}
                    size="small"
                />
                <Modal
                    visible={ppe_visible}
                    title={ppeInfo.names}
                    footer={null}
                    onCancel={this.ClosePpeModal}
                    className="review-skill-ppe-modal"
                >
                    {
                        ppe_loading ? <Loading /> :
                            (
                                <div className="ppe-items">
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">队员名称：</Col>
                                        <Col span={17} offset={1} className="ppe-text">{ppeInfo.vname}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">获证时间：</Col>
                                        <Col span={17} offset={1}
                                            className="ppe-text">{ppeInfo.datetime || '无'}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">到期时间：</Col>
                                        <Col span={17} offset={1}
                                            className="ppe-text">{ppeInfo.is_long === '1' ? ppeInfo.expire_time : '长期 / 无有效期'}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">发证机构：</Col>
                                        <Col span={17} offset={1}
                                            className="ppe-text">{ppeInfo.organization_name || '无'}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">技能名称：</Col>
                                        <Col span={17} offset={1} className="ppe-text">{ppeInfo.names}</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">技能图标：</Col>
                                        <Col span={17} offset={1} className="ppe-text">
                                            <img src={config.imgUrl + ppeInfo.icon} alt="" className="ppe-img"
                                                width="60" height="60" title={ppeInfo.names} /></Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={6} className="ppe-lable">技能证书：</Col>
                                        <Col span={17} offset={1} className="ppe-text">
                                            {
                                                (ppeInfo.images || []).map((ppe, i) => {
                                                    return (
                                                        <a href={config.imgUrl + ppe} target="_blank" key={i}>
                                                            <img src={config.imgUrl + ppe} alt=""
                                                                width="120" height="120" /></a>
                                                    )
                                                })
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            )
                    }
                </Modal>
            </div>
        )
    }
}

ReSkill.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReSkill



// WEBPACK FOOTER //
// ./src/routes/review/ReSkill.jsx